var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 16.2025C25 15.61 24.9464 15.0475 24.8544 14.5H16.1954V17.8825H21.1532C20.931 18.9925 20.2797 19.93 19.3142 20.5675V22.8175H22.272C24.0038 21.25 25 18.94 25 16.2025Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1954 25.0001C18.6781 25.0001 20.7548 24.1901 22.272 22.8176L19.3141 20.5676C18.4866 21.1076 17.4367 21.4376 16.1954 21.4376C13.7969 21.4376 11.7662 19.8551 11.0383 17.7176H7.98844V20.0351C9.49802 22.9751 12.6015 25.0001 16.1954 25.0001Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0383 17.7175C10.8467 17.1775 10.7471 16.6 10.7471 16C10.7471 15.4 10.8544 14.8225 11.0383 14.2825V11.965H7.98846C7.3601 13.18 6.99995 14.545 6.99995 16C6.99995 17.455 7.3601 18.82 7.98846 20.035L11.0383 17.7175Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1954 10.5625C17.5517 10.5625 18.7624 11.02 19.7203 11.9125L22.341 9.3475C20.7548 7.8925 18.6781 7 16.1954 7C12.6015 7 9.49802 9.025 7.98844 11.965L11.0383 14.2825C11.7662 12.145 13.7969 10.5625 16.1954 10.5625Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.bd5dc58385a60d190af051751f51e89b.svg";
export { ForwardRef as ReactComponent };